if (!customElements.get('new-media-gallery')) {
    customElements.define(
      'new-media-gallery',
      class MediaGallery extends HTMLElement {
        constructor() {
          super();
          this.elements = {
            liveRegion: this.querySelector('[id^="GalleryStatus"]'),
            viewer: this.querySelector('[id^="Slider-Gallery"]'),
            thumbnails: this.querySelector('[id^="Slider-Thumbnails"]'),
          };
          this.initSlider();
          this.mql = window.matchMedia('(min-width: 901px)');
          if (!this.elements.thumbnails) return;
          // Flickity injects viewport wrappers; never keep list semantics on the gallery track.
          this.removeListSemantic();
          const silderheight = this.elements.viewer.clientHeight;
          this.elements.thumbnails.style.width = `${silderheight}px`;
        }

        initSlider() {
          const viewer = this.elements.viewer
          const thumbnails = this.elements.thumbnails
          const options = JSON.parse(viewer.getAttribute('data-option'));
          const thumOptions = JSON.parse(thumbnails.getAttribute('data-option'));
          const flkty = new Flickity( viewer, options);
          const thumFlkty = new Flickity( thumbnails, thumOptions);
          
          // Store references for resize handling
          this.flkty = flkty;
          this.thumFlkty = thumFlkty;

          // Off-screen slides keep aria-hidden but must not leave modal buttons tabbable (PSI agentic).
          if (typeof bindFlickitySlideAccessibility === 'function') {
            bindFlickitySlideAccessibility(flkty);
          }
          
          setTimeout(() => {
            flkty.resize()
            thumFlkty.resize()
            if (typeof syncFlickitySlideAccessibility === 'function') {
              syncFlickitySlideAccessibility(flkty);
            }
            
            // Additional resize for 1440px+ screens
            if (window.innerWidth >= 1440) {
              setTimeout(() => {
                thumFlkty.reloadCells();
                thumFlkty.resize();
                if (typeof syncFlickitySlideAccessibility === 'function') {
                  syncFlickitySlideAccessibility(flkty);
                }
              }, 100);
            }
          }, 200);
          window.addEventListener('resize', function() {
            flkty.resize();
            const silderheight = viewer.clientHeight;
            thumbnails.style.width = `${silderheight}px`;
            thumFlkty.resize();
            if (typeof syncFlickitySlideAccessibility === 'function') {
              syncFlickitySlideAccessibility(flkty);
            }
            
            // Force flickity to recalculate at 1440px breakpoint
            setTimeout(() => {
              if (window.innerWidth >= 1440) {
                thumFlkty.reloadCells();
                thumFlkty.resize();
                if (typeof syncFlickitySlideAccessibility === 'function') {
                  syncFlickitySlideAccessibility(flkty);
                }
              }
            }, 100);
          }, true);
          
        // Add event listeners to the buttons for GA4 Event
        const pdptitle = document.querySelector('.product__title h1:not(.prd-ProductContent_Category)').innerText;
        document.querySelector('.product__media-list .next').addEventListener('click', function(e) {
          e.preventDefault();
          setPdpPromotion(pdptitle, 'PDP Image gallery buttons', 'next');
        });
        document.querySelector('.product__media-list .previous').addEventListener('click', function(e) {
          e.preventDefault();
          setPdpPromotion(pdptitle, 'PDP Image gallery buttons', 'previous');
        });
        }
  
        announceLiveRegion(activeItem, position) {
          const image = activeItem.querySelector('.product__modal-opener--image img');
          if (!image) return;
          image.onload = () => {
            this.elements.liveRegion.setAttribute('aria-hidden', false);
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
            setTimeout(() => {
              this.elements.liveRegion.setAttribute('aria-hidden', true);
            }, 2000);
          };
          // Re-assign src to fire onload when the image is already cached.
          const src = image.currentSrc || image.getAttribute('src');
          if (!src) return;
          image.removeAttribute('src');
          image.src = src;
        }
  
        preventStickyHeader() {
          this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
          if (!this.stickyHeader) return;
          this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }
  
        removeListSemantic() {
          if (!this.elements.viewer) return;
          this.elements.viewer.setAttribute('role', 'presentation');
          this.elements.viewer.querySelectorAll('.slider__slide').forEach((slide) => slide.setAttribute('role', 'presentation'));
        }
      }
    );
  }
  